import React from "react";
import { t } from "ttag";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (props: templates.HeaderPreviewTemplate) => (
    <PageSkeleton title="Nav preview" header_override={props.model.body}>
        <h1>{t`Hello World!`}</h1>
    </PageSkeleton>
);
